import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["className"],
      _excluded2 = ["className", "children"],
      _excluded3 = ["className", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/shadcn/lib/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Accordion = AccordionPrimitive.Root;
const AccordionItem = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(AccordionPrimitive.Item, _objectSpread({
    ref: ref,
    className: cn('border-b', className ?? '')
  }, props));
});
AccordionItem.displayName = 'AccordionItem';
const AccordionTrigger = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className,
    children
  } = _ref2,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/_jsx(AccordionPrimitive.Header, {
    className: "flex",
    children: /*#__PURE__*/_jsxs(AccordionPrimitive.Trigger, _objectSpread(_objectSpread({
      ref: ref,
      className: cn('flex flex-1 items-center justify-between py-4 font-medium transition-all hover:underline [&[data-state=open]>svg]:rotate-180', className ?? '')
    }, props), {}, {
      children: [children, /*#__PURE__*/_jsx(ChevronDown, {
        className: "h-4 w-4 shrink-0 transition-transform duration-200"
      })]
    }))
  });
});
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;
const AccordionContent = /*#__PURE__*/React.forwardRef((_ref3, ref) => {
  let {
    className,
    children
  } = _ref3,
      props = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/_jsx(AccordionPrimitive.Content, _objectSpread(_objectSpread({
    ref: ref,
    className: "overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("div", {
      className: cn('pb-4 pt-0', className ?? ''),
      children: children
    })
  }));
});
AccordionContent.displayName = AccordionPrimitive.Content.displayName;
export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };